{
    "CaisClientDataSummaryCols": [
        {
            "display": "true",
            "ui_columnname": "File Type",
            "db_columnname": "fileType",
            "datatype": "String",
            "mappingkey": "fileType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Processed",
            "db_columnname": "processedcount",
            "datatype": "String",
            "mappingkey": "processedcount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Accepted",
            "db_columnname": "acceptedcount",
            "datatype": "String",
            "mappingkey": "acceptedcount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Rejected",
            "db_columnname": "rejectedcount",
            "datatype": "String",
            "mappingkey": "rejectedcount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        }
    ],
    "CaisFileProcessingSummaryCols": [
        {
            "display": "true",
            "ui_columnname": "File Name",
            "db_columnname": "fileName",
            "datatype": "String",
            "mappingkey": "fileName",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Total Records",
            "db_columnname": "recordCount",
            "datatype": "String",
            "mappingkey": "recordCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Good Count",
            "db_columnname": "goodRecordCount",
            "datatype": "String",
            "mappingkey": "goodRecordCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Rejected Count",
            "db_columnname": "rejRecordCount",
            "datatype": "String",
            "mappingkey": "rejRecordCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        }
    ],
    "CaisDetailByExceptionCodeCols": [
        {
            "display": "true",
            "ui_columnname": "Exception",
            "db_columnname": "failureCode",
            "datatype": "String",
            "mappingkey": "failureCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Description",
            "db_columnname": "failureDescription",
            "datatype": "String",
            "mappingkey": "failureDescription",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "FDID",
            "db_columnname": "fdidCount",
            "datatype": "String",
            "mappingkey": "fdidCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Person",
            "db_columnname": "personCount",
            "datatype": "String",
            "mappingkey": "personCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Entity",
            "db_columnname": "entityCount",
            "datatype": "String",
            "mappingkey": "entityCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Supplement",
            "db_columnname": "supplementCount",
            "datatype": "String",
            "mappingkey": "supplementCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "LTID",
            "db_columnname": "ltidCount",
            "datatype": "String",
            "mappingkey": "ltidCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "TID",
            "db_columnname": "tidCount",
            "datatype": "String",
            "mappingkey": "tidCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Total",
            "db_columnname": "totalCount",
            "datatype": "String",
            "mappingkey": "totalCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        }
    ],
    "caisGenerationSubmissionSummaryCols": [
        {
            "display": "true",
            "ui_columnname": "File Name",
            "db_columnname": "fileName",
            "datatype": "String",
            "mappingkey": "fileName",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "FDID",
            "db_columnname": "receivedFDIDRecordCount",
            "datatype": "String",
            "mappingkey": "receivedFDIDRecordCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Person",
            "db_columnname": "receivedNaturalRecordCount",
            "datatype": "String",
            "mappingkey": "receivedNaturalRecordCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Legal Entity",
            "db_columnname": "receivedLegalEntityRecordCount",
            "datatype": "String",
            "mappingkey": "receivedLegalEntityRecordCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "TID",
            "db_columnname": "receivedTIDsCount",
            "datatype": "String",
            "mappingkey": "receivedTIDsCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Time Stamp",
            "db_columnname": "fileModified",
            "datatype": "String",
            "mappingkey": "fileModified",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        }
    ],
    "CaisSubmissionDataSummaryCols": [
        {
            "display": "true",
            "ui_columnname": "File Type",
            "db_columnname": "fileType",
            "datatype": "String",
            "mappingkey": "fileType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Submitted",
            "db_columnname": "submittedcount",
            "datatype": "String",
            "mappingkey": "submittedcount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Accepted",
            "db_columnname": "acceptedcount",
            "datatype": "String",
            "mappingkey": "acceptedcount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Rejected",
            "db_columnname": "rejectedcount",
            "datatype": "String",
            "mappingkey": "rejectedcount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        }
    ],
    "CaisSubmissionDetailSummaryCols": [
        {
            "display": "true",
            "ui_columnname": "File Name",
            "db_columnname": "fileName",
            "datatype": "String",
            "mappingkey": "fileName",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Submission Status",
            "db_columnname": "submissionStatus",
            "datatype": "String",
            "mappingkey": "submissionStatus",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Time Stamp",
            "db_columnname": "receiptTimestamp",
            "datatype": "String",
            "mappingkey": "receiptTimestamp",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        }
    ]
}